<template>
  <img
    v-if="logoSrc"
    :src="logoSrc"
    alt=""
    :width="size"
    :height="size"
    class="file-type-icon"
  >
  <aha-icon
    v-else
    maintainColor
    :name="iconName"
    :width="size"
    :height="size"
    class="file-type-icon"
  />
</template>

<script>
export default {
  name: 'FileTypeIcon',
  props: {
    logoSrc: { type: String, default: '' },
    iconName: { type: String, default: 'document' },
    size: { type: [Number, String], default: 24 },
  },
}
</script>
